module.exports = __webpack_public_path__ + "static/media/Качалов В., Маслов Д. (НУ).80fb2b20.pdf";